<div class="custom-dialog">
    <div class="header">
        <span>Reset Password</span>        
    </div>
    <div *ngIf="errorMessage" class="errorMessage">{{errorMessage}}</div>
    <div class="message">
        <div>Password must contain the following:</div>
        <div [class]="hasLowerCaseLetters ? 'valid' : 'invalid'">A <b>lowercase</b> letter</div>
        <div [class]="hasUpperCaseLetters ? 'valid' : 'invalid'">A <b>capital (uppercase)</b> letter</div>
        <div [class]="hasNumber ? 'valid' : 'invalid'">A <b>number</b></div>
        <div [class]="hasSpecialCharacter ? 'valid' : 'invalid'">A <b>special character</b></div>
        <div [class]="hasMinimumCharacters ? 'valid' : 'invalid'">Minimum <b>8 characters</b></div>
      </div>
    <mat-form-field [class.error]="showError && !hasValidPassword">
        <mat-label>Password</mat-label>
        <input matInput type="text" [(ngModel)]="data.password" type="password" autocomplete="off">    
    </mat-form-field>
    <mat-form-field [class.error]="(showError && !hasValidPassword) || (data.password && data.confirmPassword && data.password !== data.confirmPassword)">
        <mat-label>Confirm Password</mat-label>
        <input matInput type="text" [(ngModel)]="data.confirmPassword" type="password" autocomplete="off">    
    </mat-form-field>
    <div class="footer">  
        <app-button (onClick)="onSave()" label="Save" class="save-btn" className="primary-alt" [showSpinner]="showSpinner"></app-button>
        <app-button (onClick)="onLogout()" label="Logout" class="logout-btn" className="secondary-alt"></app-button>
    </div>
</div>